import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db, appId } from '../firebase';
import { FileDown, Loader } from 'lucide-react';

const Reportes = () => {
    const [multas, setMultas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    useEffect(() => {
        const path = `artifacts/${appId}/public/data/multas`;
        const q = query(collection(db, path));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const multasData = [];
            querySnapshot.forEach((doc) => {
                multasData.push({ id: doc.id, ...doc.data() });
            });
            setMultas(multasData);
        });
        return () => unsubscribe();
    }, []);

    const exportToPDF = async () => {
        setMessage({ text: '', type: '' });
        setIsLoading(true);
        try {
            const { default: jsPDF } = await import('jspdf');
            await import('jspdf-autotable');

            const doc = new jsPDF();
            doc.text("Reporte de Multas", 14, 16);
            doc.autoTable({
                head: [['Fecha', 'RUC/DNI', 'Razón Social', 'Monto', 'Estado']],
                body: multas.map(m => [ new Date(m.fecha_infraccion).toLocaleDateString(), m.ruc_dni, m.razon_social_nombre, `S/ ${Number(m.monto).toFixed(2)}`, m.estado ]),
                startY: 20
            });
            doc.save('reporte_multas.pdf');
        } catch (error) {
            console.error("Error al exportar a PDF:", error);
            setMessage({ text: 'Error al generar PDF. Asegúrese de tener las dependencias instaladas (npm install jspdf jspdf-autotable).', type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    const exportToExcel = async () => {
        setMessage({ text: '', type: '' });
        setIsLoading(true);
        try {
            const XLSX = await import('xlsx');
            const worksheet = XLSX.utils.json_to_sheet(multas.map(m => ({
                'Fecha Infracción': new Date(m.fecha_infraccion).toLocaleString(), 'RUC/DNI': m.ruc_dni, 'Razón Social': m.razon_social_nombre,
                'Establecimiento': m.nombre_establecimiento, 'Monto Original': Number(m.monto), 
                'Descuento Aplicado (%)': m.descuento_aplicado, 'Monto Final': m.monto_final,
                'Estado': m.estado, 'Fiscalizador': m.fiscalizador_nombre,
            })));
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Multas");
            XLSX.writeFile(workbook, "reporte_multas.xlsx");
        } catch(error) {
            console.error("Error al exportar a Excel:", error);
            setMessage({ text: 'Error al generar Excel. Asegúrese de tener la dependencia instalada (npm install xlsx).', type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            {message.text && (
                <div className={`p-4 mb-4 rounded-md ${message.type === 'error' ? 'bg-red-100 text-red-800' : ''}`}>
                    {message.text}
                </div>
            )}
            <p className="mb-6 text-gray-600">Descargue el listado completo de multas registradas en el sistema en formato PDF o Excel.</p>
            <div className="flex gap-4">
                <button onClick={exportToPDF} disabled={isLoading} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700 disabled:bg-red-300">
                    {isLoading ? <Loader className="animate-spin w-5 h-5" /> : <FileDown className="w-5 h-5" />}
                    Exportar a PDF
                </button>
                <button onClick={exportToExcel} disabled={isLoading} className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700 disabled:bg-green-300">
                     {isLoading ? <Loader className="animate-spin w-5 h-5" /> : <FileDown className="w-5 h-5" />}
                    Exportar a Excel
                </button>
            </div>
        </div>
    );
};

export default Reportes;